export default "__VITE_ASSET__f53a383b__"